import { Collection } from 'firestorter';
import format from 'string-template';

import { firestorePaths, pathPlaceholder } from '../utils/paths';
import BaseDocument from './BaseDocument';

const MsgTemplateName = {
  FIRST_MESSAGE: '1st Message',
};

const InstagramMsgTemplateName = {
  IG_AUTOMATED_MESSAGE: 'IG Automated Message',
  IG_FOLLOW_UP_MESSAGE: 'IG Follow up Message',
};

class MsgTemplate extends BaseDocument {
  get name() {
    return this.data.name;
  }

  get msgBody() {
    return this.data.msgBody;
  }

  get order() {
    return this.data.order;
  }

  get isDefault() {
    return this.data.isDefault;
  }

  get salesStage() {
    return this.data.salesStage;
  }

  get attachmentUrl() {
    return this.data.attachmentUrl;
  }

  get attachmentCategory() {
    return this.data.attachmentCategory;
  }

  /** The provider this copy is for (a `ContactProvider`, e.g. RCS); unset for the standard copy. */
  get msgProvider() {
    return this.data.msgProvider;
  }

  get coach() {
    return this.data.coach || '';
  }

  get isEnabled() {
    return this.data.isEnabled ?? true;
  }

  get version() {
    return this.data.version ?? 1;
  }

  get current() {
    return this.data.current;
  }

  get createdByUserName() {
    return this.data?.createdByUserName || '';
  }

  get createdAt() {
    return this.data.createdAt;
  }

  static async getDefaultTemplates() {
    const msgTemplateCollection = new Collection(firestorePaths.DEFAULT_MSG_TEMPLATES, {
      createDocument: (source, options) => new MsgTemplate(source, options),
      query: (query) => query
        .orderBy('order', 'asc'),
    });
    await MsgTemplate.initCollection(msgTemplateCollection);
    return msgTemplateCollection;
  }

  /**
   * Gets the msg templates by coach
   *
   * @param {string} coachId - The coach id
   * @param {string} [templateName] - The name of the template (optional)
   * @return {Promise<Collection>} - The collection of msg templates
   */
  static async getTemplatesByCoach(coachId, templateName) {
    const msgTemplateCollection = new Collection(
      format(firestorePaths.COACH_MSG_TEMPLATES, { [pathPlaceholder.COACH_ID]: coachId }),
      {
        createDocument: (source, options) => new MsgTemplate(source, options),
        query: (query) => {
          if (templateName) {
            return query.where('name', '==', templateName);
          }
          return query.orderBy('order', 'asc');
        },
      },
    );
    await MsgTemplate.initCollection(msgTemplateCollection);
    return msgTemplateCollection;
  }

  static async addNewTemplate(templateData, version) {
    const newCoachMsgTemplate = new Collection(format(firestorePaths.COACH_MSG_TEMPLATES, {
      [pathPlaceholder.COACH_ID]: templateData.coach,
    }));
    await newCoachMsgTemplate.add({
      ...templateData,
      version,
    });
  }
}

export default MsgTemplate;
export { MsgTemplateName, InstagramMsgTemplateName };
